// import React from 'react';
// import Select, { createFilter } from 'react-select';
// import { withStyles, Typography, Paper, MenuItem } from '@material-ui/core';

// // ✅ Basic MUI styles for select
// const styles = theme => ({
//     root: {
//         minHeight: '32px !important',
//         fontSize: '14px',
//     },
//     placeholder: {
//         position: 'absolute',
//         left: 8,
//         fontSize: 14,
//         color: theme.palette.text.secondary,
//     },
//     paper: {
//         position: 'absolute',
//         zIndex: 9999,
//         marginTop: theme.spacing(),
//         left: 0,
//         right: 0,
//     },
// });


// function NoOptionsMessage(props) {
//     return (
//         <Typography color="textSecondary" style={{ padding: 8 }} {...props.innerProps}>
//             {props.children}
//         </Typography>
//     );
// }

// function Option(props) {
//     return (
//         <MenuItem
//             ref={props.innerRef}
//             selected={props.isFocused}
//             component="div"
//             style={{
//                 fontSize: '12px',
//                 fontWeight: 400,
//                 fontStyle: 'normal',
//                 lineHeight: '17px',
//                 color: 'rgba(120, 121, 142, 1)'
//             }}
//             {...props.innerProps}
//         >
//             {props.children}
//         </MenuItem>
//     );
// }

// // ✅ Placeholder
// function Placeholder(props) {
//     return (
//         <Typography style={{ color: "#999", fontSize: '12px', }}>
//             {props.children}
//         </Typography>
//     );
// }

// // ✅ Menu wrapper
// function Menu(props) {
//     return (
//         <Paper square style={{
//             marginTop: '5px', padding: '5px', fontSize: '12px',
//             fontWeight: 400,
//             fontStyle: 'normal',
//             lineHeight: '17px',
//             color: 'rgba(120, 121, 142, 1)'
//         }}>
//             {props.children}
//         </Paper>
//     );
// }

// const components = {
//     Menu,
//     NoOptionsMessage,
//     Option,
//     Placeholder,
// };

// // ✅ New Simple Select Component
// const SimpleSelect = (props) => {
//     const { classes, options, placeholder, onChange, value } = props

//     return (
//         <Select
//             className={classes.root}
//             options={options}
//             placeholder="Select an option"
//             value={value}
//             onChange={onChange}
//             menuPortalTarget={document.body}
//             components={components}
//             filterOption={createFilter({ ignoreAccents: false })}
//             styles={{
//                 placeholder: (base) => ({
//                     ...base,
//                     color: "#999",       // change placeholder text color
//                     fontSize: "12px",    // font size
//                 }),
//                 control: (provided, state) => ({
//                     ...provided,
//                     minHeight: "32px",
//                     height: "32px",
//                     fontSize: '12px',
//                     fontWeight: 400,
//                     fontStyle: 'normal',
//                     lineHeight: '17px',
//                     border: "1px solid rgba(213, 214, 221, 1) !important",
//                     boxShadow: "none",
//                     "&:hover": {
//                         border: "1px solid rgba(213, 214, 221, 1)", // same border on hover
//                     },
//                 }),
//                 indicatorSeparator: () => ({
//                     display: "none",   // ✅ removes that .css-d8oujb element
//                 }),
//                 dropdownIndicator: (base) => ({
//                     ...base,
//                     alignSelf: "flex-start",   // ✅ moves arrow to top
//                     paddingTop: "7px",         // tweak spacing
//                     paddingBottom: "0px",
//                     color: "rgba(95, 96, 113, 1)",          // change color
//                     transform: "translateX(-4px)", // move left
//                     svg: {
//                         width: "16px",   // smaller width
//                         height: "16px",  // smaller height
//                     },
//                 }),
//             }}
//         />
//     );
// };

// export default withStyles(styles, { withTheme: true })(SimpleSelect);


import React from 'react';
import Select, { createFilter } from 'react-select';
import { withStyles, Typography, Paper, MenuItem } from '@material-ui/core';

const styles = theme => ({
    root: {
        minHeight: '32px !important',
        fontSize: '14px',
    },
    placeholder: {
        position: 'absolute',
        left: 8,
        fontSize: 14,
        color: theme.palette.text.secondary,
    },
    paper: {
        position: 'absolute',
        zIndex: 9999,
        marginTop: theme.spacing(),
        left: 0,
        right: 0,
    },
});

function NoOptionsMessage(props) {
    return (
        <Typography color="textSecondary" style={{ padding: 8 }} {...props.innerProps}>
            {props.children}
        </Typography>
    );
}

function Option(props) {
    return (
        <MenuItem
            // react-select v4/v5 uses innerRef; if you’re on v5.8+, ref also works:
            ref={props.innerRef}
            selected={props.isFocused}
            component="div"
            style={{
                fontSize: '12px',
                fontWeight: 400,
                fontStyle: 'normal',
                lineHeight: '17px',
                color: 'rgba(120, 121, 142, 1)',
            }}
            {...props.innerProps}
        >
            {props.children}
        </MenuItem>
    );
}

function Placeholder(props) {
    const { children, innerProps } = props;
    return (
        <Typography style={{
            color: '#999', fontSize: '12px',
            fontWeight: 400,
            padding: '5px 8px 6px 8px',
            fontStyle: 'normal',
            lineHeight: '17px',
        }}  {...innerProps}    >
            {children}
        </Typography>
    );
}

function Menu(props) {
    // ⭐️ Important: pass through innerProps so events/ARIA work
    const { children, innerProps } = props;
    return (
        <Paper
            square
            style={{
                marginTop: '5px',
                padding: '5px',
                fontSize: '12px',
                fontWeight: 400,
                fontStyle: 'normal',
                lineHeight: '17px',
                color: 'rgba(120, 121, 142, 1)',
            }}
            {...innerProps}
        >
            {children}
        </Paper>
    );
}

const components = {
    Menu,
    NoOptionsMessage,
    Option,
    Placeholder,
};

const SimpleSelect = (props) => {
    const { classes, placeholder = 'Select an option', ...rest } = props;

    return (
        <Select
            className={classes.root}
            // forward everything else (value, onChange, options, isSearchable, isClearable, id, isLoading, etc.)
            {...rest}
            placeholder={placeholder}
            components={components}
            menuPortalTarget={document.body}
            // if you portal, fixed positioning avoids scroll jank
            menuPosition="fixed"
            filterOption={createFilter({ ignoreAccents: false })}
            styles={{
                valueContainer: (base) => ({
                    ...base,
                    padding: '5px 8px 6px 8px',  // controls space for both placeholder & value
                  }),
                singleValue: (base) => ({
                    ...base,
                    fontSize: "12px",   // change font size
                    fontWeight: 400,
                    padding: '5px 8px 6px 8px',
                    fontStyle: 'normal',
                    lineHeight: '17px',
                }),
                clearIndicator: (base) => ({
                    ...base,
                    padding: "2px",
                    cursor: "pointer",
                    color: "rgba(200, 0, 0, 0.6)", // change cross color
                    ":hover": {
                        color: "red", // hover color
                    },
                    svg: {
                        width: "14px",  // resize cross icon
                        height: "14px",
                    },
                }),
                placeholder: (base) => ({
                    ...base,
                    color: '#999',
                    fontSize: '12px',
                    fontWeight: 400,
                    padding: '5px 8px 6px 8px',
                    fontStyle: 'normal',
                    lineHeight: '17px',
                }),
                control: (provided) => ({
                    ...provided,
                    minHeight: '32px',
                    height: '32px',
                    fontSize: '12px',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    lineHeight: '17px',
                    border: '1px solid rgba(213, 214, 221, 1) !important',
                    boxShadow: 'none',
                    '&:hover': {
                        border: '1px solid rgba(213, 214, 221, 1)',
                    },
                }),
                indicatorSeparator: () => ({ display: 'none' }),
                dropdownIndicator: (base) => ({
                    ...base,
                    alignSelf: 'flex-start',
                    paddingTop: '7px',
                    paddingBottom: 0,
                    color: 'rgba(95, 96, 113, 1)',
                    transform: 'translateX(-4px)',
                    svg: { width: '16px', height: '16px' },
                }),
                menu: (base) => ({
                    ...base,
                    zIndex: 99999,
                    position: 'fixed',
                }),
                menuPortal: (base) => ({
                    ...base,
                    zIndex: 99999,
                }),
                menuList: (base) => ({
                    ...base,
                    zIndex: 99999,
                }),
            }}
        />
    );
};

export default withStyles(styles, { withTheme: true })(SimpleSelect);
